var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mc-table",class:[{
      'mc-table--fit': _vm.fit,
      'mc-table--striped': _vm.stripe,
      'mc-table--border': _vm.border || _vm.isGroup,
      'mc-table--hidden': _vm.isHidden,
      'mc-table--group': _vm.isGroup,
      'mc-table--fluid-height': _vm.maxHeight,
      'mc-table--scrollable-x': _vm.layout.scrollX,
      'mc-table--scrollable-y': _vm.layout.scrollY,
      'mc-table--enable-row-hover': !_vm.store.states.isComplex,
      'mc-table--enable-row-transition': (_vm.store.states.data || []).length !== 0 && (_vm.store.states.data || []).length < 100
    }, _vm.tableSize ? ("mc-table--" + _vm.tableSize) : '']},[_c('div',{ref:"hiddenColumns",staticClass:"hidden-columns"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"mc-table__header-wrapper"},[_c('table-header',{attrs:{"store":_vm.store}})],1),_vm._v(" "),_c('div',{ref:"bodyWrapper",staticClass:"mc-table__body-wrapper",class:[_vm.layout.scrollX ? ("is-scrolling-" + _vm.scrollPosition) : 'is-scrolling-none'],style:([_vm.bodyHeight])},[_c('table-body',{style:({
	           width: _vm.bodyWidth
	        }),attrs:{"context":_vm.context,"store":_vm.store,"stripe":_vm.stripe,"row-class-name":_vm.rowClassName,"row-style":_vm.rowStyle,"highlight":_vm.highlightCurrentRow}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


// WEBPACK FOOTER //
// ./src/components/table/table.vue